// boundingBoxHelper.js
import * as PIXI from 'pixi.js';
import {setPixiActiveObject} from "../../Store/reducers/pixiCanvasSlice.js";
import PixiCanvas from './PixiCanvas.jsx';

const controlNames = [
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'rotate'
];


export function createBoundingBox(textDesign) {
    const box = new PIXI.Graphics();
    box.lineStyle(2, '#FF7F7F', 1);
    box.drawRect(-textDesign.width / 2, -textDesign.height / 2, textDesign.width, textDesign.height);
    box.x = textDesign.x;
    box.y = textDesign.y;
    return box;
}

export function createResizeControls() {
    const controls = {};
    controlNames.forEach(name => {
        controls[name] = new PIXI.Graphics();
    });
    const controlRadius = 5;
    Object.keys(controls).forEach((corner) => {
        const control = controls[corner];
        control.beginFill(0x000000);
        control.drawCircle(0, 0, controlRadius);
        control.endFill();
        control.interactive = true;
        control.buttonMode = true;
        control.name = corner;
    });
    controls.rotateLine = new PIXI.Graphics()
    return controls;
}

export function updateBoundingBox(boundingBox, width, height, x, y,rotation) {
    if (boundingBox) {
        boundingBox.clear();
        boundingBox.lineStyle(2, '#050303', 1);
        boundingBox.drawRect(-width / 2, -height / 2, width, height);
        boundingBox.x = x;
        boundingBox.y = y;
        boundingBox.rotation=rotation;
    }
}

export function updateControlPositionsForControls(controls, width, height, x, y, rotation) {
    const halfWidth = width / 2;
    const halfHeight = height / 2;
    const positions = {
        topLeft: { x: x - halfWidth, y: y - halfHeight },
        topRight: { x: x + halfWidth, y: y - halfHeight },
        bottomLeft: { x: x - halfWidth, y: y + halfHeight },
        bottomRight: { x: x + halfWidth, y: y + halfHeight },
    };

    // Helper to rotate a point about center (x, y)
    const rotatePoint = (point, center, angle) => {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const dx = point.x - center.x;
        const dy = point.y - center.y;
        return {
            x: center.x + dx * cos - dy * sin,
            y: center.y + dx * sin + dy * cos,
        };
    };

    // Apply rotation to each control position
    Object.keys(positions).forEach((key) => {
        positions[key] = rotatePoint(positions[key], { x, y }, rotation);
    });

    // Set the rotated positions for the corner and side controls
    controls.topLeft.position.set(positions.topLeft.x, positions.topLeft.y);
    controls.topRight.position.set(positions.topRight.x, positions.topRight.y);
    controls.bottomLeft.position.set(positions.bottomLeft.x, positions.bottomLeft.y);
    controls.bottomRight.position.set(positions.bottomRight.x, positions.bottomRight.y);

    // For the rotate control:
    // 1. Start with the unrotated top center point.
    let topCenter = { x: x, y: y - halfHeight };
    // 2. Rotate the top center point.
    topCenter = rotatePoint(topCenter, { x, y }, rotation);
    // 3. Place the rotate control a fixed distance away from that point.
    const rotateMargin = 20;
    // Compute the vector from the center to the rotated top center.
    const dx = topCenter.x - x;
    const dy = topCenter.y - y;
    const len = Math.sqrt(dx * dx + dy * dy) || 1;
    // Normalize the vector and extend it by rotateMargin.
    const rotateControlPos = {
        x: topCenter.x + (dx / len) * rotateMargin,
        y: topCenter.y + (dy / len) * rotateMargin,
    };
    controls.rotate.position.set(rotateControlPos.x, rotateControlPos.y);

    // If you have a connecting line between the top of the box and the rotate control:
    if (controls.rotateLine) {
        controls.rotateLine.clear();
        controls.rotateLine.lineStyle(1, 0x000000, 1);
        controls.rotateLine.moveTo(topCenter.x, topCenter.y);
        controls.rotateLine.lineTo(rotateControlPos.x, rotateControlPos.y);
    }
}

export function createTextSprite(texture, savedState, dimensions, zoom, initialScale, canvas, bounds = {}) {
    const {
        boundaryX1,
        boundaryX2,
        boundaryY1,
        boundaryY2,
        defaultSize,
        minSize,
        maxSize,
        BASE_WIDTH,
        BASE_HEIGHT,
    } = bounds;

    texture.baseTexture.mipmap = PIXI.MIPMAP_MODES.ON;
    const sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5);
   const  localSave = JSON.parse(savedState);

    if (localSave && localSave.textDesign) {
        sprite.x = localSave.textDesign.x;
        sprite.y = localSave.textDesign.y;
        sprite.rotation = localSave.textDesign.rotation;
        sprite.scale.set(localSave.textDesign.scaleX, localSave.textDesign.scaleY);
    } else if (
        boundaryX1 != null && boundaryX2 != null &&
        boundaryY1 != null && boundaryY2 != null &&
        defaultSize != null
    ) {
        
        const width  = boundaryX2 - boundaryX1; 
        const height = boundaryY2 - boundaryY1;

  const scaleFactor = defaultSize / sprite.texture.height;

  sprite.scale.set(scaleFactor);

  const boundaryCenterX = boundaryX1 + width  / 2;
  const boundaryCenterY = boundaryY1 + height / 2;

 console.log("calculation",boundaryCenterX,boundaryCenterY)

  sprite.x = boundaryCenterX * ( canvas.screen.width/ BASE_WIDTH )   ;
  sprite.y = boundaryCenterY  * (canvas.screen.height / BASE_HEIGHT );


        // sprite.x = (boundaryX1 + boundaryX2) / 2;
        // sprite.y = (boundaryY1 + boundaryY2) / 2;

        // const originalWidth = sprite.texture.orig ? sprite.texture.orig.width : sprite.texture.width;
        // const originalHeight = sprite.texture.orig ? sprite.texture.orig.height : sprite.texture.height;

        // const scaleX = defaultSize / originalWidth;
        // const scaleY = defaultSize / originalHeight;
        // const uniformScale = Math.min(scaleX, scaleY);

        // sprite.scale.set(uniformScale, uniformScale);

    } else {

        // Fallback if boundaries aren't provided.
        sprite.x = dimensions.width / 2;
        sprite.y = dimensions.height / 2;
        sprite.scale.set(1, 1);
    }
    // Attach the min and max size constraints to the sprite for later use.
    sprite.minSize = minSize || 0;
    sprite.maxSize = maxSize || Infinity;

    sprite.alpha = 0.9;
    sprite.interactive = true;
    sprite.buttonMode = true;
    sprite.roundPixels = true;

    return sprite;
}



export function createDisplacementSprite(texture,dimensions, canvas) {
    const sprite = new PIXI.Sprite(texture);
    const cameraContainer = canvas?.cameraContainer;

    sprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
    sprite.width = dimensions.width;
    sprite.isDisplacementSprite = true;
    sprite.height = dimensions.height;
    cameraContainer.addChild(sprite);
    return sprite;
}
